import { useQuery } from '@tanstack/react-query';
import { useApp } from '../../../../hooks/use-app';
import { SqlOptions, GlobalFilter, SystemTypeEnum } from '../column-filter.types';
import { returnValuesFor } from '../helpers';

type FilterValues = {
  formData: SqlOptions,
  category: string,
  type: SystemTypeEnum,
  filter: GlobalFilter,
};

export default function useFilterValues({
  formData, category, type, filter,
}: FilterValues) {
  const { api } = useApp();

  const loadValuesForFilter = async () => returnValuesFor(
    api, category, formData, filter, type,
  );

  return useQuery([`fetch_filter_values_${category}`, filter], () => loadValuesForFilter(), {
    enabled: !!formData,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
